import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import { Form, Field } from "react-final-form";
import { Grid } from "@mui/material";
import TextInput from "../../reusableComponents/components/generics/TextInput";
import ContributionPlanPicker from "../../pickers/ContributionPlanPicker";
import InsureePicker from "../../pickers/InsureePicker";
import { useDispatch, useSelector } from "react-redux";
import DatePickers from "../../pickers/DatePicker";
import {
  fetchPolicyHolderInfo,
  updateManagementStaff,
  updatePolicyHolderInsuree,
} from "../../action";
import CalendarPicker from "../../pickers/CalenderPicker";
import Dropdown from "../../reusableComponents/components/generics/Dropdown";

const MedicalStaffDialog = ({
  setShowUpdateDialog,
  showUpdateDialog,
  rowData,
  params,
  refresh
}) => {
  const dispatch = useDispatch();
  const SignInSuccess = useSelector((state) => state?.profileReducer);
  const { t } = useTranslation();

  const fosaHealth = useSelector((state) => state);

  const fosaHealthFacilitySpecialtyItems =
    fosaHealth?.fosaReducer?.fosaHealthFacilitySpecialtyItems;
  const fosaHealthFacilityPositionItems =
    fosaHealth?.fosaReducer?.fosaHealthFacilityPositionItems;

  // const [insureeData, setInsureeData] = useState();
  useEffect(() => {
    if (SignInSuccess?.currentUserResponseData?.id) {
      dispatch(
        fetchPolicyHolderInfo(SignInSuccess?.currentUserResponseData?.id)
      );
    }
  }, [dispatch, SignInSuccess?.currentUserResponseData]);

  const handleClose = () => {
    setShowUpdateDialog(false);
  };
  const onSubmit = async (values) => {
    const ph = rowData?.insuree?.policyholderinsureeSet?.edges?.[0]?.node?.policyHolder
    const data = ph ? ph : {}
    const value = { values, ...data };
    dispatch(updateManagementStaff(value, rowData?.insuree?.id,params));
    setTimeout(() => {
      if(refresh) {
        refresh()
      }
    }, 100)
    handleClose()
  };

  const jsonExt = rowData?.insuree?.policyholderinsureeSet?.edges?.[0]?.node?.jsonExt

  return (
    <React.Fragment>
      <Dialog open={showUpdateDialog}>
        <DialogTitle>{t("modifyStaffManagement")}</DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item>
              <Grid container>
                <Form
                  onSubmit={onSubmit}
                  // validate={validate}
                  initialValues={{
                    insureeNo: rowData?.insuree?.chfId,
                    name: rowData?.otherName,
                    positionId:!!jsonExt &&JSON.parse(jsonExt)?.position_id,
                    specialityId:!!jsonExt &&JSON.parse(jsonExt)?.speciality_id,
                  }}
                  render={({
                    handleSubmit,
                    form,
                    submitting,
                    pristine,
                    values,
                    errors,
                  }) => (
                    // setFormValues(values),
                    <form onSubmit={handleSubmit}>
                      <Grid container>
                        <Grid item xs={12} className="common-input">
                          <Field
                            name="insureeNo"
                            component={InsureePicker}
                            label={t("Temporary CAMU No./CAMU No.")}
                            required
                            type="text"
                            insureeNo={values}
                            disabled={true}
                          />
                        </Grid>

                        <Grid item xs={12} className="common-input">
                          <Field
                            name="positionId"
                            component={Dropdown}
                            label={"Fonctions"}
                            options={fosaHealthFacilityPositionItems.map((item) => ({
                              ...item,
                              label: item.designation,
                              value: item.id,
                            }))}
                            required
                          />
                        </Grid>

                        <Grid item xs={12} className="common-input">
                          <Field
                            name="specialityId"
                            component={Dropdown}
                            label={"Spécialités"}
                            options={fosaHealthFacilitySpecialtyItems.map((item) => ({
                              ...item,
                              label: item.designation,
                              value: item.id,
                            }))}
                            required
                          />
                        </Grid>
                      </Grid>
                      <DialogActions>
                        <Button onClick={handleClose}>{t("cancel")}</Button>

                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          size="large"
                          disabled={submitting || pristine}
                          // style={{ width: "100%" }}
                          // fullWidth
                        >
                          {t("Add")}
                        </Button>
                      </DialogActions>
                    </form>
                  )}
                />
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default MedicalStaffDialog;
